export default "/images/e74424b39a5c4ab6f533b8f671e57eee.avif";